import { FETCH_ALL_PENDING_REQU } from '../../constants/actionTypes'

export default (laPending = {}, action) => {
    switch (action.type) {
        case FETCH_ALL_PENDING_REQU:
            return action.payload;
        default:
            return laPending;
    }
}